import {z} from 'zod'
import {buildEntrySchemaFor} from '../entry'
import {PageSettingsSchema} from './pageSettings'
import {TemplateF2Schema} from './templateF2'
import {TemplateFreeFormSchema} from './templateFreeForm'
import {TemplateUniverse23WaitlistSchema} from './templateUniverse23Waitlist'
import {TemplateContactSalesSchema} from './templateContactSales'
import {TemplateFeaturesCopilotSchema} from './templateFeaturesCopilot'

function buildPageSchemaForTemplate<Template extends z.ZodTypeAny>(templateSchema: Template) {
  return buildEntrySchemaFor('containerPage', {
    fields: z.object({
      path: z.string(),
      settings: PageSettingsSchema.optional(),
      template: templateSchema,
      title: z.string(),
    }),
  })
}

const FreeFormPageSchema = buildPageSchemaForTemplate(TemplateFreeFormSchema)
export type FreeFormPage = z.infer<typeof FreeFormPageSchema>

const Universe23WaitlistPageSchema = buildPageSchemaForTemplate(TemplateUniverse23WaitlistSchema)
export type Universe23WaitlistPage = z.infer<typeof Universe23WaitlistPageSchema>

const ContactSalesPageSchema = buildPageSchemaForTemplate(TemplateContactSalesSchema)
export type ContactSalesPage = z.infer<typeof ContactSalesPageSchema>

const F2PageSchema = buildPageSchemaForTemplate(TemplateF2Schema)
export type F2Page = z.infer<typeof F2PageSchema>

const FeatureCopilotPageSchema = buildPageSchemaForTemplate(TemplateFeaturesCopilotSchema)
export type FeatureCopilotPage = z.infer<typeof FeatureCopilotPageSchema>

export function isFeatureCopilotPage(page: unknown): page is FeatureCopilotPage {
  return FeatureCopilotPageSchema.safeParse(page).success
}

// Add FeatureCopilotPageSchema to the ContainerPageSchema union
const ContainerPageSchema = z.union([
  FreeFormPageSchema,
  Universe23WaitlistPageSchema,
  FeatureCopilotPageSchema,
  F2PageSchema,
  ContactSalesPageSchema,
])

export type ContainerPage = z.infer<typeof ContainerPageSchema>
export function toContainerPage(item: unknown): ContainerPage {
  return ContainerPageSchema.parse(item)
}
